// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

import { getNewIndexWithHiddenFields } from '../utils/collab-utils';

interface ReorderFieldParams {
  fieldId: string;
  newIndex: number;
  hiddenFields?: string[];
}

export function reorderField(
  ydb: Database,
  { fieldId, newIndex, hiddenFields }: ReorderFieldParams
): void {
  ydb.mutate((db) => {
    const adjustedIndex = getNewIndexWithHiddenFields(newIndex, db.fields, hiddenFields);
    db.reorderField(fieldId, adjustedIndex);
  });
}
